import React from 'react'
import LocalizedCurrencyNumber from '~/views/components/currency/LocalizedCurrencyNumber'
import styled from 'styled-components'
import { useCurrentUserContext } from '~/views/contexts/CurrentUserContext'
import Text from '~/views/components/ui/Text'
import { isNumber } from 'lodash'
import WarningIconAndTooltip from '~/views/components/ProjectOverview/components/WarningIconAndTooltip'
import { getCurrencySymbol } from '~/utils/currency/currency'
import { LoadingTextPlaceholder } from '~/views/components/ProjectOverview/components/ProjectOverviewCard'
import { useStaticLabels } from 'shared/hooks/use-static-labels'

const TotalProfitContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`

type TotalProfitProps = {
  totalProfit?: number | null
  loading: boolean
}

export default function TotalProfitContent({
  totalProfit,
  loading,
}: TotalProfitProps) {
  const [getCommonLabel] = useStaticLabels(['common'])

  return (
    <TotalProfitContainer>
      <Text>{getCommonLabel('current')}</Text>

      <TotalProfitValueContent totalProfit={totalProfit} loading={loading} />
    </TotalProfitContainer>
  )
}

/**
 * =====----===--=--===----=====
 * TotalProfitValueContent
 */

type TotalProfitValueContentProps = {
  totalProfit?: number | null
  loading: boolean
}

function TotalProfitValueContent({
  totalProfit,
  loading,
}: TotalProfitValueContentProps) {
  const { currentUser } = useCurrentUserContext()

  if (loading) {
    return <LoadingTextPlaceholder />
  }

  return !isNumber(totalProfit) ? (
    <DefaultProfitContentValue />
  ) : (
    <Text weight="bold">
      <LocalizedCurrencyNumber number={totalProfit} currentUser={currentUser} />
    </Text>
  )
}

/**
 * =====----===--=--===----=====
 * DefaultProfitContentValue
 */

const TooltipContentContainer = styled.div`
  padding: 0;

  .title {
    margin: 0;
  }

  .list-container {
    margin: 0;
    padding-top: 3px;
    color: #888;
    padding-left: 2em;

    .list-item {
      margin: 0;
      font-size: 0.85em;
      line-height: 135%;
    }
  }
`

function DefaultProfitContentValue() {
  const { currentUser } = useCurrentUserContext()

  return (
    <Text data-component-name={'accrued-value'}>
      <Text weight={'bold'}>
        {getCurrencySymbol(currentUser?.organization?.currencyCode)} -
      </Text>{' '}
      <WarningIconAndTooltip>
        <TooltipContentContainer>
          <Text className={'title'}>Total profit unavailable due to:</Text>

          <ul className={'list-container'}>
            <li className={'list-item'}>Missing Full Loaded Costs for users</li>
          </ul>
        </TooltipContentContainer>
      </WarningIconAndTooltip>
    </Text>
  )
}
